import React from "react";
import Marquee from "react-fast-marquee";

// === Import brand logos ===
import logo01 from "../../../images/brand/arca-continental-logo-blanco.png";
import logo02 from "../../../images/brand/CinemexLogoBlanco.png";
import logo03 from "../../../images/brand/hnkwhithelogo.png";
import logo04 from "../../../images/brand/LogoCocaBlanco.png";
import logo05 from "../../../images/brand/topochicoblanco.png";
import logo06 from "../../../images/brand/Cinepolis-white.png";
import logo07 from "../../../images/brand/petstarLogoBlanco.png";
import logo08 from "../../../images/brand/logo-sisamex-blanco.png";
import logo09 from "../../../images/brand/AlenLogoBlanco.png";
import logo10 from "../../../images/brand/logofundacionblanco.png";
import logo11 from "../../../images/brand/tecatelogoblanco.png";

const BrandSection: React.FC = () => {
  const brandLogos = [
    logo01,
    logo02,
    logo03,
    logo04,
    logo05,
    logo06,
    logo07,
    logo08,
    logo09,
    logo10,
    logo11,
  ];

  return (
    <section className="brand pb-150">
      <div className="container">
        <div className="sec-title sec-title-center brand-sec-title text-center mb-40">
          <p className="sub-title">
            Tenemos la <span>confianza</span> de nuestros clientes
          </p>
        </div>
      </div>

      {/* === Marquee (CSS handles smooth scroll) === */}
      <Marquee
        gradient={false}
        speed={30}
        pauseOnHover
        direction="left"
        className="brand-marquee ac-brand-marquee marquee-left"
      >
        <div className="ac-brand-inner ul_li_between">
          {brandLogos.map((logo, i) => (
            <div key={i} className="xb-brand-item">
              <img src={logo} alt={`brand-logo-${i + 1}`} />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
};

export default BrandSection;
